(function (Drupal) {
    Drupal.behaviors.ctaDoctor = {

      attach: function (context, settings) {
        
        const containerDoctor = document.querySelector(".container-doctor", context);
  
        if (containerDoctor == null) return; 
  
        const containerData = containerDoctor.querySelector(".container-left");
  
        if (containerData == null) return; 
        let existingLink = containerData.querySelector("a.google-link");
  
        if (!existingLink) {
          const googleLink = document.createElement("a");
          googleLink.href = "https://oficinavirtual.clinicacolsanitas.com/";
          googleLink.textContent = "Agenda tu cita";
          googleLink.className = "btn btn-primary";
          googleLink.target = "_blank"; 
          
          containerData.appendChild(googleLink);
        }
      }
    }
  })(Drupal);
  